import { render } from "./DetailBox.vue?vue&type=template&id=43a8657a&scoped=true&ts=true"
import script from "./DetailBox.vue?vue&type=script&lang=ts"
export * from "./DetailBox.vue?vue&type=script&lang=ts"

import "./DetailBox.vue?vue&type=style&index=0&id=43a8657a&scoped=true&lang=scss"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a8657a"]])

export default __exports__